import './ProfileLoading.css';

const ProfileLoading = () => {
  return (
    <div id="profile-loading">
      <i className="fa-solid fa-spinner"></i>
    </div>
  )
}

export default ProfileLoading;